<template>
  <div class="container-pacientes-atendimento">
    <div class="header-pacientes-atendimento">
      <span>Pacientes em atendimento</span>
    </div>
    <div v-if="pacientesEmAtendimento.length > 0" class="container-pacientes-list">
      <div v-for="paciente in pacientesEmAtendimento" :key="paciente.id">
        <MolensTooltip max-width="300px" posicao="right">
          <div class="item-paciente">
            <label>{{ paciente.codigo }}</label>
            <label class="max-label">&ensp;-&ensp;{{ paciente.nomePaciente }}</label>
          </div>
          <template #content>
            <label><strong>{{ paciente.nomeDentista }}</strong></label><br/>
            <span>{{ paciente.descricao }}</span>
          </template>
        </MolensTooltip>
      </div>
    </div>
    <div class="nenhum-paciente" v-else>Nenhum paciente em atendimento!</div>
  </div>
</template>

<script>

import MolensTooltip from '@/views/components/MolensTooltip.vue'

export default {
    name: 'PacientesEmAtendimento',
    components: {MolensTooltip},
    props: {
        pacientesEmAtendimento: Array
    }
}
</script>


<style scoped lang="stylus">

.container-pacientes-atendimento
  box-shadow rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset
  border-radius 5px
  height 350px
  overflow hidden

.header-pacientes-atendimento
  padding-left 5px
  height 41.59px
  display flex
  align-items center
  border-bottom 1px solid #ddd
  font-weight bold
  color var(--theme-primary)

.nenhum-paciente
  height 90%
  display flex
  align-items center
  justify-content center
  text-align center
  padding 5px

.item-paciente
  background-color var(--theme-secondary)
  padding 0 5px
  color white
  border-bottom 1px solid #ccc
  display flex
  align-items center

.item-paciente:hover
  background-color var(--theme-primary)
  cursor pointer

.item-paciente > label:hover
  cursor pointer

.container-pacientes-list
  height 300px
  overflow-y auto

.max-label
  display inline-block
  max-width 90%
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.container-detalhes
  color black

  label
    font-size 15px
    font-weight bold

.tooltip-shadow.menuable__content__active
  box-shadow 0 4px 14px rgba(0, 0, 0, 0.3)

</style>